import * as less from './Labels.less';
import React from 'react/addons';
const ReactCSSTransitionGroup = React.addons.CSSTransitionGroup;
import WindowResizeComponent from '../components/WindowResizeComponent';
import { State, Navigation } from 'react-router';
import playlists from '../playlists';
import classnames from 'classnames';
import labels from '../playlists/labels';
import productLinks from '../playlists/product-links';

const labelOrder = ['burger', 'foundation', 'golf-channel', 'minimal-wave', 'plant', 'ppu', 'rockers', 'soundway', 'stones-throw', 'workshop'];

export default class Labels extends WindowResizeComponent(State, Navigation) {
  constructor(props, context) {
    super(props, context);

    this.slideDown = this.slideDown.bind(this);
  }

  createPlayStation(labelId) {
    return (e) => {
      e.preventDefault();

      this.props.actions.play(labelId);
    };
  }

  createLink(label) {
    return (e) => {
      e.preventDefault();

      this.transitionTo('labels', { labelId: label });
    };
  }

  slideDown(e) {
    e.preventDefault();
    const content = React.findDOMNode(this.refs.labelsContent);
    const destination = $(content).offset().top;
    $('html, body').animate({
      scrollTop: destination
    }, 150);
  }

  render() {
    const territory = 'en';
    const params = this.getParams();
    const isPlaying = this.props.playlist.isPlaying && this.props.playlist.playlist.key === params.labelId;
    const currentLabelIndex = labelOrder.indexOf(params.labelId);
    const nextLabelIndex = currentLabelIndex + 1 >= labelOrder.length ? 0 : currentLabelIndex + 1;
    const prevLabelIndex = currentLabelIndex - 1 < 0 ? labelOrder.length - 1 : currentLabelIndex - 1;
    const label = labels[params.labelId];
    const labelLinks = productLinks[params.labelId];
    const labelExternalUrls = label.urls;
    let labelExternalUrlAnchors = null;

    const imageStyles = {
      height: this.state.windowHeight,
      backgroundImage: label ? `url(${label.header})` : null
    };

    const logoStyles = {
      top: (this.state.windowHeight - 94) / 2
    };

    if (labelExternalUrls) {
      let homePageLink = null;
      let facebookLink = null;
      let twitterLink = null;

      if (labelExternalUrls.homepage) {
        homePageLink = <li className='text-center'><a href={labelExternalUrls.homepage.url} target='_blank'>{labelExternalUrls.homepage.title}</a></li>;
      }

      if (labelExternalUrls.facebook) {
        facebookLink = <li className='text-center'><a href={labelExternalUrls.facebook.url} target='_blank'>{labelExternalUrls.facebook.title}</a></li>;
      }

      if (labelExternalUrls.twitter) {
        twitterLink = <li className='text-center'><a href={labelExternalUrls.twitter.url} target='_blank'>{labelExternalUrls.twitter.title}</a></li>;
      }

      if (homePageLink !== null || facebookLink !== null || twitterLink !== null) {
        labelExternalUrlAnchors = <p className='label-urls'>
          <ul className='list-unstyled'>
            {homePageLink}
            {facebookLink}
            {twitterLink}
          </ul>
        </p>;
      }
    }

    const buttonClassNames = classnames('call-out call-out-show labels-logo', {
      solid: isPlaying,
      dark: isPlaying
    });

    return (
      <div className='page-labels-container'>
        <div key={params.labelId}>
          <div className='labels-header' style={imageStyles}>
            <a href='#' onClick={this.createLink(labelOrder[prevLabelIndex])} className='prev-link'>Prev</a>
            <a href='#' onClick={this.createLink(labelOrder[nextLabelIndex])} className='next-link'>Next</a>
            <a href='#' onClick={this.createPlayStation(params.labelId)} className={buttonClassNames} style={logoStyles}>
              <span className='title'>{label.title}</span><span className='subtitle'>{label.subtitle}</span><span className='more-info'>{label.moreInfo}</span><span className='onair'>—on air</span>
            </a>
            <div className='labels-arrow'><a href='#' onClick={this.slideDown}>Go to Content</a></div>
          </div>
          <div ref='labelsContent' className='labels-content-logo'>
            <img src={label.logo} width={label.logoSize} />
          </div>
          <div className='labels-content'>
            <p>{label.description}</p>
            {labelExternalUrlAnchors}
            <h2 className='label-products-title'>{label.title} Shop</h2>
            <div className='label-products'>
              <div className='label-hat'>
                <a href={labelLinks.hat[territory]} target='_blank' className='product-image'><img src={label.hat.image} width='290'/></a>
                <a href={labelLinks.hat[territory]} target='_blank' className='title'>{label.hat.title}</a>
                <a href={labelLinks.hat[territory]} target='_blank' className='subtitle'>{label.hat.subtitle}</a>
              </div>
              <div className='label-disk'>
                <a href={labelLinks.disk} target='_blank' className='product-image'><img src={label.disk.image} width='290'/></a>
                <a href={labelLinks.disk} target='_blank' className='title'>{label.disk.title}</a>
                <a href={labelLinks.disk} target='_blank' className='subtitle'>{label.disk.subtitle}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/routes/Labels.jsx
 **/